var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"size":"small","color":"transparent"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"icon fas fa-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }